module.exports = __webpack_public_path__ + "img/QA.5393ff29.svg";